export default __webpack_public_path__ + "static/media/alert.dc765e9f.svg";